<template>
  <div class="card_box">
    <Card>
      <!-- 主表 -->
      <div slot="title" class="titlebox">
        <span class="title">{{$t('label.Inquiry.InquiryFor')}}</span>
        <Icon type="ios-create-outline" class="applyicon" />
        <!-- <Button type="primary" long  class="add">
          <Icon type="ios-add" style="margin-right:5px;" />添加
        </Button>-->
      </div>
      <Form ref="formdata" :model="formdata" :rules="rule">
        <!-- 主表表单 -->
        <table class="form-table form-table-print">
          <tbody>
            <tr>
              <!-- 询价编号 -->
              <th class="requiredIitm">{{$t('label.Inquiry.InquiryNo')}}</th>
              <td>
                <Form-item prop="inquiryId">
                  <Input type="text" v-model="formdata.inquiryId" disabled />
                </Form-item>
              </td>
              <!-- 申请人 -->
              <th class="requiredIitm">{{$t('label.Inquiry.Applicants')}}</th>
              <td>
                <Form-item prop="applicantUserId">
                  <Input type="text" v-model="sqr" disabled />
                </Form-item>
              </td>
              <!-- 申请日期 -->
              <th class="requiredIitm">{{$t('label.Inquiry.ApplicationDate')}}</th>
              <td>
                <Form-item prop="applyDate">
                  <ab-date
                    :disabled="true"
                    style="width:100%;"
                    v-model="formdata.applyDate"
                    format="yyyy-MM-dd"
                  ></ab-date>
                </Form-item>
              </td>
            </tr>
            <!-- 新加功能 公司-据点选择 -->
            <tr>
              <!-- 公司 -->
              <th class="requiredIitm">
                <span>{{ $t('InquiryApply.InquiryCompany') }}</span>
              </th>
              <td>
                <Form-item prop="applyCompanyName">
                  <Input type="text" v-model="formdata.applyCompanyName" disabled />
                </Form-item>
              </td>
              <!-- 据点 -->
              <th class="requiredIitm">
                <span>{{ $t('InquiryApply.InquiryStronghoId') }}</span>
              </th>
              <td>
                <Form-item prop="applyStrongholdName">
                  <Input type="text" v-model="formdata.applyStrongholdName" disabled />
                </Form-item>
              </td>
              <!-- 申请部门 -->
              <th class="requiredIitm">{{$t('label.Inquiry.ApplyDepartment')}}</th>
              <td>
                <Form-item prop="applyDepartmentName">
                  <Input type="text" v-model="formdata.applyDepartmentName" disabled />
                </Form-item>
              </td>
            </tr>
            <tr>
              <!-- 报价截止日 -->
              <th class="requiredIitm">{{$t('label.Inquiry.Deadline')}}</th>
              <td>
                <Form-item prop="quoteDeadline">
                  <ab-date
                    :disabled="true"
                    style="width:100%;"
                    v-model="formdata.quoteDeadline"
                    format="yyyy-MM-dd"
                  ></ab-date>
                </Form-item>
              </td>
               <!-- 案件名 -->
              <th class="requiredIitm"><span>{{$t('label.Inquiry.caseName')}}</span></th>
              <td colspan="3">
                <Form-item prop="caseName">
                  <Input type="text" v-model="formdata.caseName" disabled  />
                </Form-item>
              </td>
            </tr>
            <tr>
              <!-- 背景目的 -->
              <th class="requiredIitm">{{$t('label.Inquiry.Purpose')}}</th>
              <td colspan="5">
                <Form-item prop="objective">
                  <Input type="textarea" autosize v-model="formdata.objective" disabled />
                </Form-item>
              </td>
            </tr>
            <tr v-if="permission.xjsq.inform!=='n'">
              <!-- 仅人事可见 -->
              <th class="requiredIitm">
              <span>{{$t("label.Inquiry.inform")}}</span>
              </th>
              <td  style="text-align:left;" colspan="6">
                <Form-item prop="inform">
                  <RadioGroup v-model="formdata.inform">
                      <Radio
                        disabled
                        label="1"
                      >{{$t('LABEL-011')}}</Radio>
                      <Radio
                        disabled
                        label="0"
                      >{{$t('LABEL-010')}}</Radio>
                    </RadioGroup>
                </Form-item>
              </td>
            </tr>
            <tr v-if="permission.xjsq.inform!=='n'">
              <!-- 仅总务可见 -->
              <th class="requiredIitm">
                <span>{{$t('label.Inquiry.limit')}}</span>
              </th>
              <td colspan="5" style="text-align:left;">
                <Form-item prop="limit">
                  <RadioGroup v-model="formdata.limit">
                    <Radio disabled label="1">{{$t('LABEL-011')}}</Radio>
                    <Radio disabled label="0">{{$t('LABEL-010')}}</Radio>
                  </RadioGroup>
                </Form-item>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- 其他事项 -->
        <div>
          <div class="table_box" @mouseover="pmdisplayover" @mouseout="pmdisplayout">
            <div class="itemTitle">
              <Icon type="ios-information-circle" class="icon" />
              <span style="cursor: pointer;font-size:13px;">{{$t('label.Inquiry.PurchaseTips')}}</span>

              <Icon
                type="ios-help-circle-outline"
                class="icon"
                style="margin-left:10px;color:#000;"
              />
            </div>
            <table class="i-iview-table form-table" style="margin-top:10px;" v-show="pmdisplayflg">
              <thead>
                <tr class="firstRow">
                  <th style="width:5%;">
                    <span style="font-size: 14px;">{{'NO.'}}</span>
                  </th>
                  <th style="width:30%;text-align:left;">
                    <span style="font-size: 14px;">{{$t('label.Inquiry.Physical.Item')}}</span>
                  </th>
                  <th style="width:15%;text-align:left;">
                    <span style="font-size: 14px;">{{$t('label.Inquiry.PurchasingDepartment')}}</span>
                  </th>
                  <th style="width:30%;text-align:left;">
                    <span style="font-size: 14px;">{{$t('label.Inquiry.Consulting')}}</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(val,index) in contactList" :key="index" style="height:42px;">
                  <td style>{{index+1}}</td>
                  <td style="text-align:left;" v-html="val.name"></td>
                  <td style="text-align:left;" v-html="val.content"></td>
                  <td style="text-align:left;" v-html="val.contactNumber"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- <Form-item>
        <Button type="primary" @click="handleSubmit('formdata')">提交</Button>
        <Button type="primary" @click="handleReset('formdata')" style="margin-left: 8px">重置</Button>
        </Form-item>-->
      </Form>
      <!-- 供应商展示 -->
      <div class="table_box" style="margin-top:30px">
        <table
          class="i-iview-table form-table form-table-print form-table-print-sub table_box_content"
        >
          <thead>
            <tr class="firstRow" style="height: 42px;">
              <th style="width:170px;">{{$t('label.Inquiry.Content')}}</th>
              <th class style="width:180px;">{{$t('label.InquiryDecisionApprove.Reason')}}</th>
              <th
                class
                style="width:200px;"
              >{{$t('label.InquiryInvitationApply.SupplierDetail.SupplierName')}}</th>
              <th
                style="width:100px;"
              >{{$t('label.InquiryOfferApprove.SupplierDetail.PriceAmount')}}</th>
              <th
                class
                style="width:140px;"
              >{{$t('label.InquiryOfferApprove.SupplierDetail.Attachment')}}</th>
              <th class style="width:120px;">{{$t('label.InquiryOfferApprove.ChangePriceamount')}}</th>
              <th class style="width:140px;">{{$t('label.InquiryOfferApprove.ChangeFile')}}</th>
              <th class style="width:170px;">{{$t('label.Inquiry.Service.Note')}}</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="val in formDynamic.items">
              <tr
                v-for="(item,count) in val.swgysList"
                style="height: 42px;"
                :class="{'trActive':item.choose==='1'}"
                :key="count +'11'"
              >
                <td
                  :rowspan="val.swgysList.length"
                  v-if="count===0"
                  style="background-color: #fff;"
                >{{ val.itemName }}</td>
                <td>{{ item.selectReason ? item.selectReason : '' }}</td>
                <td>{{ item.vendorName }}</td>
                <td
                  style="text-align:right;"
                >{{item.priceAmount ? `${item.priceAmount.toFixed(2)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}}</td>
                <td>
                  <ab-upload v-model="item.detailFile" abPermission="w" :disabled="true" :format="['pdf','xlsx','xls','doc','docx','ppt','pptx','ofd','jpg','png','jpeg','bmp']"></ab-upload>
                </td>
                <td
                  style="text-align:right;"
                >{{item.changePriceamount ? `${item.changePriceamount.toFixed(2)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}}</td>
                <td>
                  <ab-upload v-model="item.changeFile" abPermission="w" :disabled="true" :format="['pdf','xlsx','xls','doc','docx','ppt','pptx','ofd','jpg','png','jpeg','bmp']"></ab-upload>
                </td>
                <td>{{ item.note }}</td>
              </tr>
            </template>
            <template v-for="val in formService.items">
              <tr
                v-for="(item,count) in val.fwgysList"
                :class="{'trActive':item.choose==='1'}"
                style="height: 42px;"
                :key="count + '22'"
              >
                <td
                  :rowspan="val.fwgysList.length"
                  v-if="count===0"
                  style="background-color: #fff;"
                >{{ val.entrustment }}</td>
                <td>{{ item.selectReason ? item.selectReason : '' }}</td>
                <td>{{ item.vendorName }}</td>
                <td
                  style="text-align:right;"
                >{{item.priceAmount ? `${item.priceAmount.toFixed(2)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}}</td>
                <td>
                  <ab-upload v-model="item.detailFile" abPermission="w" :disabled="true" :format="['pdf','xlsx','xls','doc','docx','ppt','pptx','ofd','jpg','png','jpeg','bmp']"></ab-upload>
                </td>
                <td
                  style="text-align:right;"
                >{{item.changePriceamount ? `${item.changePriceamount.toFixed(2)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}}</td>
                <td>
                  <ab-upload v-model="item.changeFile" abPermission="w" :disabled="true" :format="['pdf','xlsx','xls','doc','docx','ppt','pptx','ofd','jpg','png','jpeg','bmp']"></ab-upload>
                </td>
                <td>{{ item.note }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <!-- 通过见解 -->
      <Form ref="form" :model="listData" :rules="rules" style="margin-top:30px;">
        <Table border :columns="columns" :data="listData.items" :no-data-text="''">
          <!-- 供应商名称 -->
          <template slot-scope="{ row }" slot="vendorName">
            <span>{{row.vendorName}}</span>
          </template>
          <!-- 通过/不通过 -->
          <template slot-scope="{ row,index }" slot="adoptFig">
            <FormItem :prop="`items.${index}.adoptFig`" :rules="rules.adoptFig">
              <Select
                :disabled="permission.swgys.adoptFig!=='w'"
                v-model="listData.items[index].adoptFig"
                style="width:100%;"
                :transfer="true"
                @on-change="select($event,listData.items[index])"
              >
                <Option
                  v-for="(item,count) in list"
                  :value="item.value"
                  :key="count + 'adoptFig'"
                >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </template>
          <!-- 价格原因 -->
          <template slot-scope="{ row,index }" slot="priceCategory">
            <FormItem :prop="`items.${index}.priceCategory`" :rules="rules.priceCategory">
              <AutoComplete
                :disabled="permission.swgys.adoptFig!=='w'"
                v-model="listData.items[index].priceCategory"
                :data="row.adoptFig==='1'?lista:row.adoptFig==='0'?listc:[]"
                :transfer="true"
              ></AutoComplete>
            </FormItem>
          </template>
          <!-- 企业原因 -->
          <template slot-scope="{ row,index }" slot="priceValuation">
            <FormItem :prop="`items.${index}.priceValuation`" :rules="rules.priceValuation">
              <AutoComplete
                :disabled="permission.swgys.adoptFig!=='w'"
                v-model="listData.items[index].priceValuation"
                :data="row.adoptFig==='1'?listb:row.adoptFig==='0'?listd:[]"
                :transfer="true"
              ></AutoComplete>
            </FormItem>
          </template>
          <!-- 其他原因 -->
          <template slot-scope="{ row,index }" slot="otherReasons">
                    <Tooltip
                        style="width:100%;margin-top:5px;"
                        max-width="400"
                        :disabled="listData.items[index].otherReasons===''"
                        :content="listData.items[index].otherReasons"
                        :transfer="true"
                      >           
                  <FormItem :prop="`items.${index}.otherReasons`" :rules="rules.otherReasons">
                    <Input
                      type="text"
                      v-model="listData.items[index].otherReasons"
                      :disabled="permission.swgys.adoptFig!=='w'"
                    />
                  </FormItem>
                    </Tooltip>
          </template>
        </Table>
      </Form>
    </Card>
  </div>
</template>
<script>
import util from "@/libs/util";
export default {
  data: function() {
    return {
      contactList: [
        {
          name: $t("label.Inquiry.Camera"),
          content: $t("label.Inquiry.LegalAffairs"),
          contactNumber: $t("label.Inquiry.Liyan")
        },
        {
          name: $t("label.Inquiry.Display"),
          content: $t("label.Inquiry.SystemCourse"),
          contactNumber: $t("label.Inquiry.LiuYuanYuan")
        },
        {
          name: $t("label.Inquiry.Stationery"),
          content: $t("label.Inquiry.GeneralAffairsSection"),
          contactNumber: $t("label.Inquiry.ChenYan")
        },
        {
          name: $t("label.Inquiry.VehicleRelated"),
          content: $t("label.Inquiry.SupportDepartment"),
          contactNumber: $t("label.Inquiry.GuLingYan")
        },
        {
          name: $t("label.Inquiry.SpareParts"),
          content: $t("label.Inquiry.SupportDepartment"),
          contactNumber: $t("label.Inquiry.DingXianHua")
        },
        {
          name: $t("label.Inquiry.VehicleAccess"),
          content: $t("label.Inquiry.SupportDepartment"),
          contactNumber: $t("label.Inquiry.ZhangYiTing")
        }
      ],
      sqr: "",
      detail: false,
      //供应商数据
      listData: {
        items: []
      },
      pmdisplayflg: false,
      list: [
        {
          label: $t("label.InquiryOpinonApprove.Through02"),
          value: "0"
        },
        {
          label: $t("label.InquiryDecisionApprove.Through01"),
          value: "1"
        }
      ],
      lista: [
        $t("label.InquiryOpinonApprove.Reason01"),
        $t("label.InquiryOpinonApprove.Reason02")
      ], //通过价格
      listb: [
        $t("label.InquiryOpinonApprove.Reason03"),
        $t("label.InquiryOpinonApprove.Reason04")
      ], //通过行政
      listc: [
        $t("label.InquiryOpinonApprove.Reason05"),
        $t("label.InquiryOpinonApprove.Reason06")
      ], //不通过价格
      listd: [$t("label.InquiryOpinonApprove.Reason07")], //不通过行政
      //实物数据
      formDynamic: {
        items: [
          {
            itemName: "",
            specifications: "",
            quantity: "",
            deliveryDeadline: "",
            note: "",
            file: "",
            incompleteQr: "",
            incompleteQrt: "",
            swgysList: []
          }
        ]
      },
      //服务数据
      formService: {
        items: [
          {
            entrustment: "",
            businessHoursStart: "",
            businessHoursEnd: "",
            securityType: "",
            note: "",
            file: "",
            incompleteQr: "",
            incompleteQrt: "",
            fwgysList: []
          }
        ]
      },
      // 供应商明细校验规则
      // 主表校验规则
      rule: {
        inform: [
          {
            required: false,
            message: util.getmsg(this, "label.Inquiry.inform"),
            trigger: "change"
          }
        ],
        breakupBidFlg: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.InquiryOfferApprove.Separable"),
            trigger: "change"
          }
        ],
        applicantUserId: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.Applicants"),
            trigger: "change"
          }
        ],
        applyDepartmentName: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.ApplyDepartment"),
            trigger: "change"
          }
        ],
        applyDate: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.ApplicationDate"),
            trigger: "change"
          }
        ],
        quoteDeadline: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.Deadline"),
            trigger: "change"
          }
        ],
        inquiryId: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.InquiryNo"),
            trigger: "change"
          }
        ],
        objective: [
          {
            required: true,
            message: $t("ERR-000") + $t("label.Inquiry.Purpose"),
            trigger: "change"
          }
        ]
      },
      //见解校验
      rules: {
        adoptFig: [
          {
            required: true,
            message: util.getmsg(this, "label.InquiryDecisionApprove.Through"),
            trigger: "change"
          }
        ],

        priceCategory: [
          {
            required: true,
            message: util.getmsg(
              this,
              "label.InquiryOpinonApprove.PriceReasonable"
            ),
            trigger: "change"
          }
        ],
        priceValuation: [
          {
            required: true,
            message: util.getmsg(this, "label.InquiryOpinonApprove.Punishment"),
            trigger: "change"
          }
        ],
        otherReasons: [
          {
            required: false,
            message: util.getmsg(this, "label.InquiryOpinonApprove.Other"),
            trigger: "change"
          }
        ]
      },
      columns: [
        {
          title: $t("label.InquiryInvitationApply.SupplierDetail.SupplierName"),
          slot: "vendorName",
          align: "center",
          width: 200
        },
        {
          title: $t("label.InquiryDecisionApprove.Through"),
          slot: "adoptFig",
          align: "center",
          width: 160,
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryDecisionApprove.Through")
            );
          }
        },
        {
          title: $t("label.InquiryOpinonApprove.PriceReasonable"),
          slot: "priceCategory",
          align: "center",
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOpinonApprove.PriceReasonable")
            );
          }
        },
        {
          title: $t("label.InquiryOpinonApprove.Punishment"),
          slot: "priceValuation",
          align: "center",
          renderHeader: (h, params) => {
            return h(
              "div",
              { class: "requiredIitm" },
              $t("label.InquiryOpinonApprove.Punishment")
            );
          }
        },
        {
          title: $t("label.InquiryOpinonApprove.Other"),
          slot: "otherReasons",
          align: "center",
          width: 200
        }
      ]
    };
  },
  props: {
    parent: {
      //默认数据
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  created() {
    this.formdata = this.parent.data.xjsq;
    this.permission = this.parent.permission.xjsq;
    this.formDynamic.items = this.formdata.xjswgrList;
    this.formService.items = this.formdata.fwxxList;
    var list = [];
    var list1 = this.formDynamic.items ? this.formDynamic.items : [];
    var list2 = this.formService.items ? this.formService.items : [];
    list1.forEach(val => {
      val.swgysList.forEach(item => {
        if (item.choose === "1") {
          list.push(item);
        }
      });
    });
    list2.forEach(val => {
      val.fwgysList.forEach(item => {
        if (item.choose === "1") {
          list.push(item);
        }
      });
    });
    for (var i = 0; i < list.length; i++) {
      for (var j = i + 1; j < list.length; j++) {
        if (list[i].vendorId === list[j].vendorId) {
          list.splice(j, 1);
          j--;
        }
      }
    }
    this.listData.items = list;
    this.abHttpUtil
      .post("/common/getFullName?account=" + this.formdata.applicantUserId)
      .then(res => {
        this.sqr = res;
      });
  },
  mounted() {
  },
  methods: {
    //表单提交
    // formdata
    // formDynamic
    // formService
    handleSubmit() {
      let flg = 0;
      let validateflg = false;
      this.$refs.formdata.validate(valid => {
        if (valid) {
          flg++;
        }
      });
      this.$refs.form.validate(valid => {
        if (valid) {
          flg++;
        }
      });
      if (flg === 2) {
        //遍历供应商添加
        if (this.formDynamic.items) {
          this.formDynamic.items.forEach(val => {
            val.swgysList.forEach(item => {
              if (this.returnobj(item.vendorId)) {
                item = Object.assign(item, this.returnobj(item.vendorId));
              }
            });
          });
        }
        if (this.formService.items) {
          this.formService.items.forEach(val => {
            val.fwgysList.forEach(item => {
              if (this.returnobj(item.vendorId)) {
                item = Object.assign(item, this.returnobj(item.vendorId));
              }
            });
          });
        }

        validateflg = true;
        this.$parent.data.xjsq = { ...this.formdata };
        this.$parent.data.xjsq.xjswgrList = this.formDynamic.items;
        this.$parent.data.xjsq.fwxxList = this.formService.items;
      } else {
        this.errmsg();
        validateflg = false;
      }
      return validateflg;
    },
    //表单重置
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    // 品目鼠标移入事件
    pmdisplayover() {
      this.pmdisplayflg = true;
    },
    // 品目鼠标移出事件
    pmdisplayout() {
      this.pmdisplayflg = false;
    },
    //通过不通过事件
    select(e, data) {
      this.$set(data, "priceCategory", "");
      this.$set(data, "priceValuation", "");
    },
    //输出
    returnobj(id) {
      var obj = null;
      this.listData.items.forEach(val => {
        if (val.vendorId === id) {
          obj = {
            priceValuation: val.priceValuation,
            priceCategory: val.priceCategory,
            adoptFig: val.adoptFig,
            otherReasons: val.otherReasons ? val.otherReasons : ""
          };
        }
      });
      return obj;
    },
    errmsg() {
      this.$nextTick(() => {
        var errMsg = [];
        var errList = document.querySelectorAll(".ivu-form-item-error-tip");
        errList.forEach(val => {
          if (errMsg.indexOf(val.innerHTML) == -1) {
            errMsg.push(val.innerHTML);
          }
        });
        errMsg.forEach(val => {
          this.$Message.error({ content: val, duration: 5 });
        });
      });
    }
  }
};
</script>
<style scoped>
.item_title {
  font-weight: bold;
  padding: 10px 16px;
  border-radius: 4px 0px 0px 4px;
  margin: 15px 0px;
}
.title {
  font-size: 15px;
  font-weight: bold;
  color: #2d8cf0;
}
.add {
  width: 80px;
  margin-left: 20px;
}
.titlebox {
  display: flex;
  align-items: center;
}
.typebox {
  display: flex;
  align-items: center;
  margin: 15px 0px;
}
.typebox > span {
  margin-right: 5px;
}
</style>
